import { useDispatch } from 'react-redux';

import { ElementShownAnchor } from '@hh.ru/analytics-js';
import vacancyResponseAlertScreenShown, {
    BannerName,
} from '@hh.ru/analytics-js-events/build/xhh/applicant/response/misleading_employer_banner_element_shown';
import misleadingEmployerBannerPrimaryButtonClick from '@hh.ru/analytics-js-events/build/xhh/applicant/response/misleading_employer_banner_primary_button_click';
import { Banner, Button, Title, Text } from '@hh.ru/magritte-ui';

import translation from 'src/components/translation';
import { useSelector } from 'src/hooks/useSelector';
import { addEmployerToBlackListFromBanner } from 'src/models/employersNegativeAttributes/misleadingVacancyAlert/actions';
import { misleadingVacancySavingToBlackListSelector } from 'src/models/employersNegativeAttributes/misleadingVacancyAlert/selectors';

const TrlKeys = {
    title: 'employer.misleadingVacancyBanner.banner.title',
    button: 'employer.misleadingVacancyBanner.banner.button.submit',
    content: 'employer.misleadingVacancyBanner.banner.content',
};

interface Props {
    vacancyId: string;
    employerId: number;
    bannerName: BannerName;
    afterSubmit?: () => void;
}

export const MisleadingVacancyBanner = translation<Props>(
    ({ trls, employerId, vacancyId, bannerName, afterSubmit }) => {
        const dispatch = useDispatch();
        const saving = useSelector(misleadingVacancySavingToBlackListSelector);

        const handleSubmit = () => {
            misleadingEmployerBannerPrimaryButtonClick({ vacancyId, bannerName });
            void dispatch(addEmployerToBlackListFromBanner(employerId)).then(() => {
                afterSubmit?.();
            });
        };

        return (
            <ElementShownAnchor fn={vacancyResponseAlertScreenShown} vacancyId={vacancyId} bannerName={bannerName}>
                <Banner
                    style="warning-secondary"
                    layout="vertical"
                    showClose={false}
                    buttonsOrientation="vertical"
                    title={
                        <Title Element="h4" size="small">
                            {trls[TrlKeys.title]}
                        </Title>
                    }
                    buttonBase={
                        <Button loading={saving} mode="primary" style="accent" onClick={handleSubmit}>
                            {trls[TrlKeys.button]}
                        </Button>
                    }
                    content={<Text>{trls[TrlKeys.content]}</Text>}
                />
            </ElementShownAnchor>
        );
    }
);
